__webpack_require__.p = "https://wastehero-frontend-6zgbiyo7e-wastehero.vercel.app/";